
const $  = (s,r=document)=>r.querySelector(s);
const $$ = (s,r=document)=>[...r.querySelectorAll(s)];

/* ===== reviews — edit here, nothing else ===== */
const REVIEWS = [
  {n:5,t:"Bailey used to pace the whole way to my parents' place, two hours of scrabbling. First trip with this she was asleep before we hit the freeway. I did not expect it to change her behaviour, I just wanted my seats back.",who:"Megan R.",loc:"Portland, OR",dog:"Bailey · Golden Retriever",img:0},
  {n:5,t:"Fitted it in a RAV4 in about a minute. The footwell being filled in is the whole trick — my beagle can't wedge himself down there anymore, which was the actual problem.",who:"Dave K.",loc:"Columbus, OH",dog:"Rufus · Beagle"},
  {n:5,t:"Two muddy labs, a wet dog and a beach trip every weekend. Wipes down with a cloth. The fabric is a lot heavier than the cheap one I bought off Amazon last year, which shredded in a month.",who:"Priya S.",loc:"San Diego, CA",dog:"Nala & Otis · Labradors",img:1},
  {n:4,t:"Does exactly what it says. Took me a couple of goes to get the straps tight enough that it doesn't sag in the middle — worth doing properly, it's much better once it's taut.",who:"Tom W.",loc:"Nashville, TN",dog:"Scout · Border Collie"},
  {n:5,t:"My old girl has bad hips and couldn't brace herself on corners anymore. She's steady on this. That alone was worth it.",who:"Linda M.",loc:"Asheville, NC",dog:"Pepper · Springer Spaniel",img:3},
  {n:5,t:"Bought it for the car, ended up leaving it in. Folds flat enough that passengers can still sit on the bench without me taking it out.",who:"Chris B.",loc:"Denver, CO",dog:"Moose · Bernese Mountain Dog"}
];

/* ===== FAQ — edit here ===== */
const FAQ = [
  ["Will it fit my car?","It fits the back bench of most sedans, SUVs and crew-cab trucks — anything with two rear headrests to loop the straps over. It measures 54\" × 58\" and the straps adjust down considerably, so a compact car is fine. If you drive something unusual, message us with the model before you order."],
  ["Can my dog still wear a seatbelt tether?","Yes. There are two zipped openings for seatbelt clips or tether attachments. We'd strongly recommend using one — the hammock stops your dog sliding around, but it isn't a crash restraint and shouldn't be treated as one."],
  ["Is it actually waterproof, or just water-resistant?","The top face is 600D Oxford with a bonded waterproof backing, so liquid sits on the surface rather than soaking through to the seat. It'll handle a soaked dog, a spilled bowl or an accident. It isn't submersible — nothing in this category is."],
  ["How do I clean it?","Day to day, a damp cloth. For a deeper clean it goes in the machine on cold, gentle cycle. Hang it to dry rather than tumbling — heat can affect the waterproof backing over time."],
  ["What if my dog chews it?","The fabric is scratch-resistant and stands up to claws well, but no fabric survives a determined chewer. If yours destroys it inside 30 days, the trial covers you — tell us what happened and we'll refund it."],
  ["How fast does it ship?","Orders placed before 2pm CT ship the same business day, otherwise the next. US delivery is typically 3–5 business days with tracking, free on every order — no minimum."]
];

function stars(n){ return '★★★★★'.slice(0,n) + '☆☆☆☆☆'.slice(0,5-n); }

/* 186 reviews, distributed realistically for a 4.8 average */
const DIST = [[5,148],[4,26],[3,7],[2,3],[1,2]];

function renderDist(){
  const total = DIST.reduce((s,[,c]) => s+c, 0);
  $('#dist').innerHTML = DIST.map(([n,c]) => `
    <div class="dist__r">
      <span>${n} star</span>
      <span class="dist__b"><span class="dist__f" style="width:${(c/total*100).toFixed(1)}%"></span></span>
      <span>${c}</span>
    </div>`).join('');
}

function renderPhotos(){
  $('#photos').innerHTML = Array.from({length:6},(_,i) => `
    <figure>
      <img src="${window.__reviewImgs[i]}"
           alt="Customer photo of the Rover Rest hammock in use"
           width="600" height="600" loading="lazy" decoding="async">
    </figure>`).join('');
}

function renderReviews(){
  $('#revs').innerHTML = REVIEWS.map(r => `
    <article class="rev">
      ${r.img !== undefined ? `<img class="rev__ph" src="${window.__reviewImgs[r.img]}" alt="Photo from ${r.who}'s review" width="600" height="450" loading="lazy" decoding="async">` : ''}
      <div class="rev__s" aria-hidden="true">${stars(r.n)}</div>
      <p class="sr-only">Rated ${r.n} out of 5</p>
      <p>${r.t}</p>
      <footer class="rev__f">
        <span><strong>${r.who}</strong> · ${r.loc}</span>
        <span class="rev__v"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 13 4.5 4.5L19 7"/></svg>Verified purchase</span>
        <span>${r.dog}</span>
      </footer>
    </article>`).join('');
}

function renderFAQ(){
  $('#faq-list').innerHTML = FAQ.map(([q,a],i) => `
    <div class="faq__i">
      <h3><button class="faq__b" type="button" aria-expanded="false" aria-controls="faq-${i}">
        ${q}<span class="faq__ic" aria-hidden="true"></span></button></h3>
      <div class="faq__p" id="faq-${i}" role="region"><div class="in">${a}</div></div>
    </div>`).join('');

  $$('.faq__b').forEach(btn => {
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    panel.style.height = '0px';
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.style.height = open ? '0px' : panel.scrollHeight + 'px';
    });
    addEventListener('resize', () => {
      if (btn.getAttribute('aria-expanded') === 'true') panel.style.height = panel.scrollHeight + 'px';
    });
  });
}

/* ===== mobile menu: focus trap, Escape, scroll lock, focus return ===== */
function initMenu(){
  const burger = $('#burger'), panel = $('#menu');
  let lastFocus = null;
  const focusables = () => $$('a[href], button:not([disabled])', panel).filter(el => el.offsetParent !== null);

  function onKey(e){
    if (e.key === 'Escape'){ close(); return; }
    if (e.key !== 'Tab') return;
    const f = focusables(); if (!f.length) return;
    const first = f[0], last = f[f.length-1];
    if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  }
  function open(){
    lastFocus = document.activeElement;
    panel.dataset.open = 'true';
    burger.setAttribute('aria-expanded','true');
    document.body.classList.add('is-locked');
    focusables()[0]?.focus();
    document.addEventListener('keydown', onKey);
  }
  function close(){
    if (panel.dataset.open !== 'true') return;
    panel.dataset.open = 'false';
    burger.setAttribute('aria-expanded','false');
    document.body.classList.remove('is-locked');
    document.removeEventListener('keydown', onKey);
    (lastFocus || burger).focus();
  }
  burger.addEventListener('click', open);
  panel.addEventListener('click', e => {
    if (e.target.closest('[data-close]') || e.target.closest('a[href]')) close();
  });
}

renderDist();
renderPhotos();
renderReviews();
renderFAQ();
initMenu();

/* ---------------------------------------------------------------
   Shopify product page: gallery thumbs + variant selection
   --------------------------------------------------------------- */
(function () {
  const q  = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => [...r.querySelectorAll(s)];

  /* gallery */
  const main = q('#gal-main'), thumbs = q('#thumbs');
  if (main && thumbs) {
    const btns = qa('.gal__t', thumbs);
    const pick = i => {
      main.src = btns[i].dataset.src;
      main.alt = btns[i].dataset.alt || '';
      btns.forEach((b, n) => {
        b.setAttribute('aria-selected', String(n === i));
        b.tabIndex = n === i ? 0 : -1;
      });
    };
    thumbs.addEventListener('click', e => {
      const b = e.target.closest('.gal__t');
      if (b) pick(btns.indexOf(b));
    });
    thumbs.addEventListener('keydown', e => {
      if (!['ArrowRight', 'ArrowLeft'].includes(e.key)) return;
      e.preventDefault();
      const cur = btns.findIndex(b => b.getAttribute('aria-selected') === 'true');
      const nxt = e.key === 'ArrowRight'
        ? (cur + 1) % btns.length : (cur - 1 + btns.length) % btns.length;
      pick(nxt); btns[nxt].focus();
    });
  }

  /* variants — option buttons drive the hidden select Shopify submits */
  const sel = q('#variant-select');
  if (sel) {
    const chosen = [];
    qa('.opt').forEach(b => {
      if (b.getAttribute('aria-pressed') === 'true') chosen[+b.dataset.option - 1] = b.dataset.value;
    });
    const sync = () => {
      const want = chosen.filter(Boolean).join(' / ');
      const opt = [...sel.options].find(o => (o.dataset.title || '').trim() === want);
      if (!opt) return;
      sel.value = opt.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      const now = q('#price-now'), add = q('#add-price');
      if (now && opt.dataset.price) now.textContent = opt.dataset.price;
      if (add && opt.dataset.price) add.textContent = opt.dataset.price;
    };
    qa('.opt').forEach(btn => btn.addEventListener('click', () => {
      chosen[+btn.dataset.option - 1] = btn.dataset.value;
      qa(`.opt[data-option="${btn.dataset.option}"]`).forEach(x =>
        x.setAttribute('aria-pressed', String(x === btn)));
      sync();
    }));
  }

  /* product-page accordions (homepage FAQ handled above) */
  qa('.acc__b').forEach(btn => {
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    panel.style.height = '0px';
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.style.height = open ? '0px' : panel.scrollHeight + 'px';
    });
  });
})();
